import * as React from 'react';
import {observer} from "mobx-react"
import '../index.css';
import UebergabeItem from "./UebergabeItem";


type UebergabenList = {
    ubergaben : any
};

const itemPath = '../images/uebergaben/';

function importAll(r) {
    return r.keys().map(r);
}

const images = importAll(require.context('../../images/uebergaben', false, /\.(png|jpe?g|svg)$/));

@observer
export default class Uebergaben extends React.Component<UebergabenList> {


    render()
    {

        return (
            <div>
                <div className="header_openHours">
                    <div className="header_openHours_text">Übergaben</div>
                    <div className="header_openHours_body">Wir bedanken uns für Ihr Vertrauen!</div>
                </div>
                {this.props.ubergaben.length > 0 ?
                this.props.ubergaben.map((e) => (
                    <UebergabeItem image={itemPath + e.image} text={e.text} header={e.header} >

                    </UebergabeItem>
                    ))
                    :
                <div className="uebergaben_empty header_openHours_text">Noch keine Übergaben</div>
                }



            </div>

        );

    }


}


